import DataTable from "./RefferencesTable";

export default DataTable;